import _ from 'lodash';

import { standingOrdersComponent } from './standingOrders.component';

export const standingOrdersStateName = 'app.ticket.standingOrders';

export const standingOrdersState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: standingOrdersStateName,
    url: '/standingOrders',
    component: standingOrdersComponent.name,
    data: { requiresAuth: true },
    resolve: {
      standingOrdersAndAppointmentTransfers: (
        ticketService,
        TicketType,
        ticketId,
      ) => {
        'ngInject';

        const ticketType = TicketType.Receiving;

        return ticketService
          .fetchTransactions(ticketType, ticketId)
          .then((transactions) => {
            const standingOrders = _.filter(
              transactions.standingOrders,
              (s) => s.interval != 'none',
            );

            const appointmentTransfers = _.filter(
              transactions.standingOrders,
              (s) => s.interval == 'none',
            );
            // Combine standingOrders and scheduledTransactions
            return { standingOrders, appointmentTransfers };
          });
      },
    },
  });
};
